import { Button, DropdownMenu } from '@nexelem/components';
import { faArrowsFromLine, faEmptySet, faSnowflake } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCustomTranslation } from '../../../../../hooks';
import { openFreezeRangeModal, openToPublishRangeModal } from '../modals';
import { SimulationMetadataView } from '@nexelem/graphne-api';

type SimulationBorderSettingsDropdownProps = {
  simulationMeta: SimulationMetadataView;
};

export const SimulationBorderSettingsDropdown = ({ simulationMeta }: SimulationBorderSettingsDropdownProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Button StartIcon={<FontAwesomeIcon className="rotate-90" icon={faArrowsFromLine} />} variant="text">
          {tWrapper('range')}
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="start" className="z-50">
        <DropdownMenu.Button
          StartIcon={<FontAwesomeIcon icon={faEmptySet} />}
          onClick={() => openToPublishRangeModal({ simulationMeta })}
        >
          {tWrapper('changeToPublishRange')}
        </DropdownMenu.Button>
        <DropdownMenu.Button
          StartIcon={<FontAwesomeIcon icon={faSnowflake} />}
          onClick={() => openFreezeRangeModal({ simulationMeta })}
        >
          {tWrapper('changeFrozenRange')}
        </DropdownMenu.Button>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
